import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "backdrop", "button"]

  connect() {
    this.boundKeydown = this.handleKeydown.bind(this)
    this.boundResize = this.handleResize.bind(this)
    document.addEventListener("keydown", this.boundKeydown)
    this.mediaQuery = window.matchMedia("(min-width: 1280px)")
    this.mediaQuery.addEventListener("change", this.boundResize)
    this.close()
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundKeydown)
    this.mediaQuery?.removeEventListener("change", this.boundResize)
    document.body.classList.remove("overflow-hidden")
  }

  toggle() {
    if (this.panelTarget.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    this.panelTarget.classList.remove("hidden")
    this.backdropTarget.classList.remove("hidden")
    this.buttonTarget.setAttribute("aria-expanded", "true")
    document.body.classList.add("overflow-hidden")
  }

  close() {
    if (!this.hasPanelTarget) return

    this.panelTarget.classList.add("hidden")
    if (this.hasBackdropTarget) this.backdropTarget.classList.add("hidden")
    if (this.hasButtonTarget) this.buttonTarget.setAttribute("aria-expanded", "false")
    document.body.classList.remove("overflow-hidden")
  }

  handleKeydown(event) {
    if (event.key === "Escape") this.close()
  }

  handleResize() {
    if (this.mediaQuery.matches) this.close()
  }
}
